import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { select } from '../../../../../stores';
import { t } from '../../../../../locales';
import { getValidToken, isApp } from '../../../../../utils';
import { getToken } from '../../../../../selectors/authSelectors';
import {
  getPoInsuranceServiecs,
  getCwpInsuranceServiecs,
  isCWP,
  getHomepageShowAllService,
  getProfileFeatures,
} from '../../../selectors/serviceSelectors';
import { EmmaInsuranceService } from '../../../types/EmmaInsuranceService';
import { ServiceButton } from '../InsuranceServiceButton';
import { TOGGLE_ALL_INSURANCE_SERVICES } from '../../../actions';
import './styles.scss';
import { goto } from '../../../../../actions/historyActions';
import { getLanguage } from '../../../../../selectors/userSelectors';
import { pushHaveReadNewFeatureSingle } from '../../../../../actions/sideBarItemActions';
import { openDisclaimer } from '../../../../emma-common/actions';
import { getHaveReadNewFeatures } from '../../../../../selectors/sideBarItemSelectors';
import { getDefaultRedDotMaxCount } from '../../../../../selectors/configSelectors';
import { NewFeaturepiRes } from '../../../../../types/sideBarItemTypes';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../../utils/generalGaEventAnalytics';
import {
  getWebinarFeatureId,
  getWebinarRedDotFlag,
} from '../../../../emma-webinar/selectors/webinarSelectors';
import { updateMuleWebinarRedDot } from '../../../../emma-webinar/actions/webinarActions';

const InsuranceServicesLayout: any = (props: {
  profileFeatures?: Array<string>;
  insuranceServices: Array<EmmaInsuranceService>;
  isShowAll: boolean;
  isCWP: boolean;
  toggleAllInsuranceService: () => void;
  onClickInsuranceService: (service: EmmaInsuranceService) => void;
  haveReadNewFeatures?: Array<NewFeaturepiRes>;
  defaultRedDotMaxCount: number;
  webinarFeatureId: string;
  webinarRedDotFlag: boolean;
}) => {
  const {
    profileFeatures,
    insuranceServices,
    isShowAll,
    isCWP,
    toggleAllInsuranceService,
    onClickInsuranceService,
    haveReadNewFeatures,
    defaultRedDotMaxCount,
    webinarFeatureId,
    webinarRedDotFlag,
  } = props;

  // React Hooks for screen resize to hide show "how more toggle button"
  let serviceWrapperDom: any = null;
  const getIsShowToggle = () => {
    if (!serviceWrapperDom) {
      return null;
    } else {
      return (
        serviceWrapperDom.scrollHeight - serviceWrapperDom.offsetHeight > 20 ||
        serviceWrapperDom.offsetHeight > 160
      );
    }
  };

  window.addEventListener('resize', () => {
    const isShowToggle = getIsShowToggle();
    if (isShowToggle != null) {
      setIsShowToggle(getIsShowToggle());
    }
    if (serviceWrapperDom) {
      toggleMobileClass();
    }
  });

  const [isShowToggle, setIsShowToggle] = useState(getIsShowToggle());

  const toggleMobileClass = () => {
    if (
      serviceWrapperDom.scrollHeight - serviceWrapperDom.offsetHeight > 20 &&
      window.innerWidth <= 375
    ) {
      serviceWrapperDom.classList.add('insurance-service__body--mobile');
    } else {
      serviceWrapperDom.classList.remove('insurance-service__body--mobile');
    }
  };

  useEffect(() => {
    setIsShowToggle(getIsShowToggle());
    toggleMobileClass();
  }, [getIsShowToggle]);

  // exit if data not ready
  if (!insuranceServices) {
    return null;
  }

  let sortedInsuranceServices: Array<any> = [];
  if (profileFeatures) {
    // find intercept insurance services
    const filteredInsuranceServices: Array<EmmaInsuranceService> =
      insuranceServices.filter((item) => {
        return profileFeatures.includes(item.id);
      });

    // sort insurance services
    for (let i = 0; i < profileFeatures.length; i++) {
      if (
        _.find(filteredInsuranceServices, function (o) {
          return o.id === profileFeatures[i];
        })
      ) {
        sortedInsuranceServices.push(
          _.find(filteredInsuranceServices, function (o) {
            return o.id === profileFeatures[i];
          }),
        );
      }
    }
  } else {
    sortedInsuranceServices = [];
  }

  const getDeepLink = (service: any) => {
    if (service.deepLink) {
      return service.deepLink.host;
    } else {
      return `emma-home/mypolicy?id=${service.id}`;
    }
  };

  const onClickToGatc = (service: any) => {
    const tcWindow: any = window;
    const token = select(getToken);
    const aToken = getValidToken(token);
    try {
      // tcWindow.tC.event.partnerClicks(tcWindow, {
      //     "icon": service.label[getLanguage()],
      //     "page": window.location.pathname
      // })

      // if (service.id === 'checkcoverage') {
      if (isApp()) {
        tcWindow.dataLayer.push({
          event: 'trackEvent',
          icon: service.label[getLanguage()],
          screenName: getGaPagePath(),
          userId: aToken,
        });
      } else {
        // ga#MP5
        tcWindow.dataLayer.push({
          event: 'partnerClicks',
          icon: service.label[getLanguage()],
          screenName: getGaPagePath(),
          userId: aToken,
        });
      // HKEMMA-100917 - GA3 Decommission - Remove GA3
        // tcWindow.tC.event.partnerClicks(tcWindow, {
        //   icon: service.label[getLanguage()],
        //   screenName: getGaPagePath(),
        //   AXAID: aToken,
        // });
      }
      // }
    } catch (e) {
      handleGaError(e);
    }
  };

  const isNewFeatureDot = (id: string, redDotMaxCount?: number) => {
    // Special handling webinar
    if (id === webinarFeatureId) {
      return webinarRedDotFlag;
    }

    const featureRedDotMaxCount = redDotMaxCount
      ? redDotMaxCount
      : defaultRedDotMaxCount;
    const NewFeaturesResult = _.find(
      haveReadNewFeatures,
      (item: { id: string }) => item.id === id,
    );
    const clickCount = NewFeaturesResult ? NewFeaturesResult['clickCount'] : 0;
    return clickCount < featureRedDotMaxCount;
  };

  return (
    <div className="insurance-service">
      <div className="insurance-service__header">
        <div className="insurance-service__title">
          {t('HOMEPAGE_INSURANCE_SERVICE')}
        </div>
        <div
          className="insurance-service__toggle-wrapper"
          onClick={() => {
            if (isShowToggle) toggleAllInsuranceService();
          }}
          data-enable-ga
          data-ga-type="button"
        >
          <div className="insurance-service__toggle-btn">
            {isShowToggle && (
              <div>
                <span className="insurance-service__toggle-label--desktop">
                  {isShowAll
                    ? `${t('HOMEPAGE_SEE_LESS_SERVICE')}`
                    : `${t('HOMEPAGE_SEE_ALL_SERVICE')}`}
                </span>
                <span className="insurance-service__toggle-label--mobile">
                  {isShowAll
                    ? `${t('HOMEPAGE_SEE_LESS')}`
                    : `${t('HOMEPAGE_SEE_ALL')}`}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className={
          isShowAll
            ? 'insurance-service__body--expand'
            : 'insurance-service__body--collapse'
        }
        ref={(el) => {
          serviceWrapperDom = el;
        }}
      >
        {sortedInsuranceServices.map(
          (service: EmmaInsuranceService, index: number) => {
            const enableNewFeatureDot =
              service.id &&
              (service.enableNewFeatureDot ||
                service.enableMuleNewFeatureDot) &&
              isNewFeatureDot(service.id, service.redDotMaxCount)
                ? true
                : false;

            return service.icon && service.icon.includes('lock') ? (
              <Link
                key={service.id}
                to="#lockModal"
                data-enable-ga
                data-ga-type="button"
              >
                <div
                  className="inline-button-wrapper insurance-service__button"
                  key={service.id}
                >
                  <ServiceButton
                    key={service.id}
                    {...service}
                    enableNewFeatureDot={enableNewFeatureDot}
                  />
                </div>
              </Link>
            ) : (
              <div
                className="inline-button-wrapper insurance-service__button"
                key={service.id}
                onClick={() => {
                  onClickToGatc(service);
                  onClickInsuranceService(service);
                  goto(getDeepLink(service), t('HOME_LABEL'));
                }}
                data-enable-ga
                data-ga-type="button"
              >
                <ServiceButton
                  key={service.id}
                  {...service}
                  enableNewFeatureDot={enableNewFeatureDot}
                />
              </div>
            );
          },
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  const haveReadNewFeature = getHaveReadNewFeatures(state);
  const webinarFeatureId = getWebinarFeatureId(state);
  const webinarRedDotFlag = getWebinarRedDotFlag(state);
  return {
    profileFeatures: (getProfileFeatures(state) || []).slice(),
    insuranceServices: isCWP(state)
      ? getCwpInsuranceServiecs(state)
      : getPoInsuranceServiecs(state),
    isShowAll: getHomepageShowAllService(state),
    isCWP: isCWP(state),
    haveReadNewFeatures: haveReadNewFeature
      ? haveReadNewFeature.features
      : undefined,
    defaultRedDotMaxCount: getDefaultRedDotMaxCount(state),
    webinarFeatureId,
    webinarRedDotFlag,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    toggleAllInsuranceService: () =>
      dispatch({ type: TOGGLE_ALL_INSURANCE_SERVICES }),
    onClickInsuranceService: (service: EmmaInsuranceService) => {
      if (service.enableNewFeatureDot) {
        dispatch(
          pushHaveReadNewFeatureSingle(service.id, 1, service.redDotMaxCount),
        );
      }
      if (service.enableMuleNewFeatureDot) {
        dispatch(updateMuleWebinarRedDot(service.id));
      }
      if (
        service &&
        service.deepLink &&
        service.deepLink.query &&
        service.deepLink.query.disclaimer
      ) {
        const disclaimer: string = service.deepLink.query.disclaimer || '';
        dispatch(openDisclaimer(disclaimer));
      }
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InsuranceServicesLayout);
